<template>
  <v-row
    justify="center"
  >
    <v-dialog
      v-model="mostrarModal"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Terminos y condiciones
        </v-card-title>
        <v-card-text>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat eveniet minus autem libero harum qui ab, accusantium esse explicabo aspernatur asperiores minima rem dolore quae, voluptates deleniti aut fugiat repellat!
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="clickDialogo(null)"
          >
            Rechazar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="clickDialogo('true')"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
/**
 * Componente con modal de terminos y condiciones.
 *
 * @author Valentin Agudelo Aquite
 * @since 20/02/2020 04:06 PM.
 * @version 1.0.0
 */
export default {
  name: 'ModalTerminosCondiciones',
  props: {
    mostrarTerminos: {
      type: Boolean,
      required: true,
      description: 'atributo para mostrar o ocultar la modal de terminos y condicones'
    }
  },
  computed: {
  /**
   * es usado por el DOM para definir si la modal se muestra o no.
   *
   * @author Valentin Agudelo Aquite
   * @since 20/02/2020 04:06 PM.
   * @version 1.0.0
   */
    mostrarModal () {
      return this.mostrarTerminos
    }
  },
  methods: {
    /**
     * Retorna al componente padre si se aceptaron los terminos.
     *
     * @author Valentin Agudelo Aquite
     * @since 20/02/2020 04:06 PM.
     * @version 1.0.0
     */
    clickDialogo (valor) {
      this.$emit('aceptarTerminosCondiciones', valor)
    }
  }
}
</script>

<style>

</style>
<i18n>
{
  "es": {}
}
</i18n>
